module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADeSURBVHgB7dTBDYIwFAbg96oevMmRG27ACozgBo7gBrqJbqAbsIIbyK14IPVmIrH1PURvFNoaT/xJaZqSj/alFGBMX6RSibxWO+7BI6Jz5qHXiLjF2uQ+eDesxYGeBbWE8ONFqQU4BG2TUqoEJyZnnNr5PsNsGUU3CIVD8F7YFxcwIHEcFeaJGbxrns7r5iMQDH9wAbhqh2lZVpufwHwqNJh9OyyMESfb+4NqzGi7/bRBqSy8gyDYB+VYS8F/nA9qXTGjWH+PmBNqXzHdFb4oZ9o5Q3eFEbrpXdEx/8kLMw1747EuheMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right_arrow_icn.png
// module id = NOf0
// module chunks = 1